
export enum RateStatusCd {
	N = 'N',
	P = 'P',
	Y = 'Y'}

